/* eslint-disable */
import $ from 'jquery'
import cookie from 'react-cookies'
import {message} from 'antd'
import {baseURL} from './configTheme'
import axios from 'axios'

let jasperReport = (data) => {
  // const token = cookie.load('accessToken');
  // document.getElementById('errorText').innerText = 'در حال آماده سازی گزارش'
  // $('.jasperBtn').attr('disabled',true)
  // return axios({
  //     url: `${baseURL}${data}`,
  //     method: 'get',
  //     headers: {
  //         'CSN': '100000000000000',
  //         'CTY': 'B',
  //         'CVS': '3.10.0',
  //         'Authorization': `Bearer ${token}`
  //     },
  //     responseType: 'arraybuffer'
  // }).then(res => {
  //     var blob=new Blob([res.data], {type:"application/pdf"});
  //     var fileURL = URL.createObjectURL(blob);
  //     window.open(fileURL, '_blank');
  //     document.getElementById('errorText').innerText = ''
  //     $('.jasperBtn').attr('disabled',false)
  // }).catch(() => {
  //     document.getElementById('errorText').innerText = ''
  //     $('.jasperBtn').attr('disabled',false)
  //     message.error('خطای ساخت گزارش')
  //     return Promise.reject('در ساخت گزارش خطا ایجاد شد')
  // })

  document.getElementById('errorText').innerText = 'در حال آماده سازی گزارش'
  $('.jasperBtn').attr('disabled', true)
  var xhr = new XMLHttpRequest()
  var token = cookie.load('accessToken')
  xhr.open('GET', `${baseURL}${data}`, true)
  xhr.setRequestHeader('CSN', '100000000000000')
  xhr.setRequestHeader('CTY', 'B')
  xhr.setRequestHeader('CVS', '3.10.0')
  xhr.setRequestHeader('Authorization', `Bearer ${token}`)
  xhr.responseType = 'arraybuffer'
  xhr.onload = function(e) {
    $('.jasperBtn').attr('disabled', false)
    document.getElementById('errorText').innerText = ''
    if (this.status == 200) {
      $('.jasperBtn').attr('disabled', false)
      document.getElementById('errorText').innerText = ''
      setTimeout(() => {
        var blob = new Blob([this.response], {type: 'application/pdf'})
        var fileURL = URL.createObjectURL(blob)
        window.open(fileURL, '_blank')
        document.getElementById('errorText').innerText = ''
        $('.jasperBtn').attr('disabled', false)
      }, 500)
    } else {
      message.error(`در ساخت گزارش خطا ایجاد شد.کد خطا : ${this.status}`)
      document.getElementById('errorText').innerText = ''
      $('.jasperBtn').attr('disabled', false)
    }
  }
  xhr.onerror = function(e) {
    message.error(`در ساخت گزارش خطا ایجاد شد`)
    document.getElementById('errorText').innerText = ''
    $('.jasperBtn').attr('disabled', false)
  }
  xhr.send()
}
export default jasperReport
